<template>
  <div id="login-info">
    <div class="title semibold mb-4">Profile Information</div>
    <v-text-field label="First Name" v-model="user.first_name"></v-text-field>
    <v-text-field label="Last Name" v-model="user.last_name"></v-text-field>
    <v-text-field label="Email" v-model="user.email"></v-text-field>
    <v-text-field label="Password" v-model="user.password"></v-text-field>
    <v-select :items="roles" v-model="user.role" label="Role"></v-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      roles: [
        {value: 1, text: 'Admin'},
        {value: 2, text: 'Client'},
        {value: 3, text: 'Customer'},
        {value: 4, text: 'System Admin'}
      ]
    }
  },

  props: {
    user: Object
  }
}
</script>



// WEBPACK FOOTER //
// login-info.vue?a4aef110